<div  class="mdl-grid mdl-grid--no-spacing"
      ng-if="$root.permisos.USUARISSESSIO.read">
  <h5 class="mdl-layout-title mdl-cell--12-col">
    {{'USUARIS_SESSIO' | translate}} </h5>
  <div class="mdl-cell--12-col">
    <md-card>
      <md-card-content>
        <form class="mdl-grid mdl-grid--no-spacing">
        <table class="itec-table mdl-grid mdl-cell mdl-cell--12-col mdl-grid--no-spacing">
            <thead class="mdl-grid mdl-cell mdl-cell--12-col mdl-grid--no-spacing">
              <tr class="mdl-grid mdl-cell mdl-cell--12-col mdl-grid--no-spacing">
                <th class="mdl-cell mdl-cell--2-col" >{{'SUBSCRIPCIO' | translate}}</th>
                <th class="mdl-cell mdl-cell--2-col">{{'DEFAULT_NUMERO' | translate}}</th>
                <th class="mdl-cell mdl-cell--2-col">{{'USUARIS_SESSIO' | translate}}</th>
                <th class="mdl-cell mdl-cell--6-col">{{'USUARIS_PRODUCTE' | translate}}&nbsp;
                    <div class="circle-ok " ></div>&nbsp;{{'USUARI_CONFIRMAT_HEADER' | translate}}
                    <div class="circle-vermell"></div>&nbsp;{{'USUARI_NO_REGISTRAT_HEADER' | translate}}
                    <div class="circle-groc"></div>&nbsp;{{'USUARI_NO_CONFIRMAT_HEADER' | translate}}
                </th>
              </tr>
            </thead>
            <tbody  class="mdl-grid mdl-cell mdl-cell--12-col mdl-grid--no-spacing">
                <tr class="mdl-grid mdl-cell mdl-cell--12-col mdl-grid--no-spacing" ng-repeat="usuarisessio in ctrl.productes">
                <td class="mdl-cell mdl-cell--2-col">{{usuarisessio.nomproducte}} </td>
                <td class="tcqi--text-align-right mdl-cell mdl-cell--2-col">{{'DEFAULT_TOTAL' | translate}} =  {{usuarisessio.numllicencies}} <br>
                  <div ng-repeat="cad in usuarisessio.caducitat">
                  {{cad.caducitat}}<br>
                  <span ng-if="cad.demo"> {{'demo' | translate}}</span>
                  <span ng-if="cad.renovacio"> {{'renovacio' | translate}}<br></span>
                  </div>
                </td>
                <td  class="tcqi--text-align-right mdl-cell mdl-cell--2-col">
                  <div ng-repeat="usc in usuarisessio.userssessioclient">
                    {{'tipusclient_' + usc.tipusclient | translate}}: {{usc.numusersensessio}}
                      <button ng-if="usc.numusersensessio>0"
                        class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored"
                        title="{{::'USUARIS_SESSIO' | translate}}"
                        ng-click="ctrl.usuarisensessio(usc.usersensessio)">
                         <i class="icon-usuari"></i>
                       </button>
                  </div>
                </td>
                <td class="mdl-cell mdl-cell--6-col"> 
                  <span ng-repeat="user in usuarisessio.users">
                      <a class="itec-link
                      {{(user.deleted || user.fictici) ? 'color-vermell' : ''}}
                      {{(!user.deleted && !user.fictici && !user.confirmat) ? 'color-groc' : ''}} 
                      " ng-single-click="ctrl.viewuser({{user.id}});">
                       {{user.username}}</a>&nbsp; 
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </form>

        <div class="visualClear">&nbsp;</div>


      </md-card-content>
    </md-card>
  </div>

</div>
